<template>
  <b-card v-if="!!availability">
    <b-row>
      <b-col>
        <h5>
          {{ pkg.name }}
          <small v-if="packagePrice !== null" class="text-muted ml-2">
            {{ trans('starting_from').replace(':value', '') }}
            <dollar :value="packagePrice" />
          </small>
          <small class="text-muted d-block mt-2">
            <span v-if="start.format('YYYY-MM-DD') == end.format('YYYY-MM-DD')">
              {{ start.format('LT') }} - {{ end.format('LT') }}, {{ start.format('dddd LL') }}
            </span>
            <span v-if="start.format('YYYY-MM-DD') != end.format('YYYY-MM-DD')">
              {{ start.format('dddd LL') }} {{ start.format('LT') }} - {{ end.format('dddd LL') }} {{ end.format('LT') }}, 
            </span>
            <em v-if="availability.extendedProps.hint_availability">
              ({{ availability.extendedProps.hint_availability.count }} {{ trans('avail') }})
            </em>
          </small>
        </h5>
      </b-col>
      <b-col class="col-auto">
        <h4>
          <button type="button" class="close" @click="$emit('close')">x</button>
        </h4>
      </b-col>
    </b-row>

    <b-row v-if="organization.id == 667 && pkg.details">
        <b-col>
            <span v-html="pkg.details"></span>
        </b-col>
    </b-row>

    <package-reservation-added
      v-for="(package_invoice_item, index) in package_invoice_items"
      :key="package_invoice_item.id"
      :organization="organization"
      :pkg="pkg"
      :availability="availability"
      :invoice="invoice"
      :package_invoice_item="package_invoice_item"
      :hide-label="index != 0"
      @invoice="onInvoiceChanged"
      @removed="onRemovedMaybeClose"
      @client-changed="$emit('client-changed'); refreshOrCreateCart()"
      @last-invoice-recipient="$emit('last-invoice-recipient', $event)"
    ></package-reservation-added>

    <package-reservation-add
      :organization="organization"
      :invoice="invoice"
      :pkg="pkg"
      :availability="availability"
      :already-added="package_invoice_items.length > 0"
      :added-this-time-count="package_invoice_items.length"
      :added-any-time-count="packageAnyTimeInvoiceItems.length"
      @invoice="onInvoiceChanged"
      @client-changed="$emit('client-changed')"
      @last-invoice-recipient="$emit('last-invoice-recipient', $event)"
    ></package-reservation-add>

    <b-row class="mt-3">
      <b-col v-if="package_invoice_items.length > 0">
        <h6>{{ trans('total') }}</h6>
        <h4 class="ml-3">
          <dollar v-model="total" />
          <small v-if="total > 0 && plus_tax" class="text_muted ml-2">
            {{ trans('plus_tax').toLowerCase() }}
          </small>
          <small v-if="total > 0 && taxes_included" class="text_muted ml-2">
            {{ trans('taxes_included').toLowerCase() }}
          </small>
        </h4>
        <p>
          <small v-if="pkg.payment == 'deposit' && pkg.deposit > 0" class="d-block text-muted">
            {{ currency(pkg.deposit, '1,000[.]00')}} {{ trans('deposit_required').toLowerCase() }}
          </small>
          <small v-if="pkg.payment == 'offline'" class="d-block text-muted">
            {{ trans('to_pay_later') }}
          </small>
        </p>
      </b-col>
      <b-col class="col-auto mt-4 mb-2">
        <b-button variant="link" size="sm" @click="$emit('close')">
          <i class="fa fa-fw fa-reply"></i>
          <span class="d-none d-md-inline">{{ trans('continue_shopping') }}</span>
        </b-button>
        <b-button variant="branded" :disabled="!canCheckout" @click="onCheckout">
          <i class="fa fa-fw fa-shopping-cart"></i>
          {{ trans('checkout') }}
        </b-button>
      </b-col>
    </b-row>

    <b-row class="my-3">
      <b-col>
        <admin-modify-items-bookings
          id="package-admin-modify"
          :organization="organization"
          :invoice_items="modifyInvoiceItems"
          :bookings="modifyBookings"
          :busy="busy"
          @update="refreshOrCreateCart"
          @invoice="onInvoiceChanged"
        ></admin-modify-items-bookings>
      </b-col>
    </b-row>

  </b-card>
</template>

<script>
  import Dollar from './../billing/Dollar'
  import PackageReservationAdd from './PackageReservationAdd'
  import PackageReservationAdded from './PackageReservationAdded'
  import AdminModifyItemsBookings from './AdminModifyItemsBookings'

  export default {
    props: {
      organization: Object,
      pkg: Object,
      availability: Object,
      invoice: Object,
    },
    components: {
      Dollar,
      PackageReservationAdd,
      PackageReservationAdded,
      AdminModifyItemsBookings,
    },
    data() {
      return {
        trans: trans,
        moment: moment,
        numeral: numeral,
        lang: window.lang,
        currency: _.currency,
        error: null,
        busy: false,
      }
    },
    computed: {
      modifyBookings() {
        if (!this.invoice) return []
        return _.reduce(this.invoice.invoice_items, (bookings, item) => {
          if (!item.expired && item.package_id == this.availability.extendedProps.package_id &&
            moment(item.start).isSame(this.availability.start)) {
            bookings.push(item.booking)
          }
          return bookings
        }, [])
      },
      modifyInvoiceItems() {
        if (!this.availability || !this.invoice) return []
        let ids = []
        return _.reduce(this.invoice.invoice_items, (items, item) => {
          if (item.package_id == this.availability.extendedProps.package_id &&
            moment(item.start).isSame(this.availability.start) &&
            !item.expired) {
            items.push(item)
            ids.push(item.id)
          }
          if (item.addon_id && ids.indexOf(item.invoice_item_id) >= 0) {
            items.push(item)
          }
          return items
        }, [])
      },
      packageAnyTimeInvoiceItems() { // This package at any time
        if (!this.availability || !this.invoice) return []
        return _.reduce(this.invoice.invoice_items, (items, item) => {
          if (item.package_id == this.availability.extendedProps.package_id) {
            items.push(_.assign({
              addons: this.getAddOns(item.id),
            }, item))
          }
          return items
        }, [])
      },
      package_invoice_items() { // This package at this time
        return _.reduce(this.packageAnyTimeInvoiceItems, (items, item) => {
          if (moment(item.start).isSame(this.availability.start)) {
            items.push(item)
          }
          return items
        }, [])
      },
      packagePrice() {
        return this.pkg.price
        // Show the original price because it may have been modified
        // Old code here...
        let price = this.package_invoice_items.length > 0 ?
          this.package_invoice_items[0].price :
          (this.availability ? this.availability.extendedProps.price : null)
        return price ? parseFloat(price) : 0
      },
      total() {
        if (this.package_invoice_items.length == 0) return null;
        return _.reduce(this.package_invoice_items, (price, item) => {
          price += parseFloat(item.price) - parseFloat(item.discount) +
            _.reduce(this.invoice.invoice_items, (sum, ii) => {
              if (ii.invoice_item_id != item.id) return sum
              sum += parseFloat(ii.price)
              return sum
            }, 0)
            /*_.reduce(item.addons, (sum, addon) => {
              if (!!addon.invoice_item_id) sum += (addon.price * addon.quantity)
              return sum
            }, 0)*/
          return price
        }, 0)
      },
      plus_tax() {
        return this.package_invoice_items.length > 0 ?
          this.package_invoice_items[0].plus_tax :
          false
      },
      taxes_included() {
        return this.package_invoice_items.length > 0 ?
          this.package_invoice_items[0].taxes_included :
          false
      },
      start() {
        return this.availability ? moment(this.availability.start) : null
      },
      end() {
        return this.availability ? moment(this.availability.end) : null        
      },
      canCheckout() {
        return !this.busy &&
          this.package_invoice_items.length > 0 &&
          !this.package_invoice_items[0].expired
      },
    },
    watch: {
      availability() {
        if (this.availability && this.availability.extendedProps.package_id != this.pkg.id)
          throw `Unexpected error: pkg.id (${this.pkg.id}) does not match availability.package_id (${this.availability.extendedProps.package_id})!`
        if (this.availability && !this.doNotRefreshOnAvailabilityChange) this.refreshOrCreateCart()
        this.doNotRefreshOnAvailabilityChange = false
      },
    },
    methods: {
      onInvoiceChanged(invoice) {
        this.doNotRefreshOnAvailabilityChange = true
        this.$emit('invoice', invoice)
      },
      onRemovedMaybeClose() {
        this.$nextTick(() => {
          if (this.package_invoice_items.length == 0) this.$emit('close')
        })
      },
      getAddOns(package_invoice_item_id) {
        return _.reduce(this.pkg.addons, (addons, addon) => {
          if (addon.type == 'modifier') return addons
          let item = package_invoice_item_id ? _.find(this.invoice.invoice_items, {
            addon_id: addon.id,
            invoice_item_id: package_invoice_item_id,
          }) : null
          addons.push({
            id: addon.id,
            type: addon.type,
            invoice_item_id: item ? item.id : null,
            name: addon.name,
            quantity: (item ? item.quantity : addon.quantity) || 0,
            min_quantity: addon.min_quantity,
            max_quantity: addon.max_quantity,
            required: addon.required,
            price: item ? parseFloat(item.price) : (addon.price ? parseFloat(addon.price) : 0),
          })
          return addons
        }, [])
      },
      onCheckout() {
        let session = ''
        if (window.session_id) {
          session = `?_session=${window.session_id}`;
        }
        window.location = `${_.iframeUrlPrefix}/org/${this.organization.id}/checkout${session}`
      },
      refreshOrCreateCart() {
        //console.log('PackageReservation.refreshOrCreateCart')
        this.busy = true
        this.error = null
        axios.post(`/org/${this.organization.id}/cart`)
        .then(response => {
          this.busy = false
          this.$emit('invoice', response.data)
        })
        .catch(error => {
          this.busy = false
          this.error = _.errorFromAjax(error)
          _.toastError(this, this.error)
        })
      },
    },
    mounted() {
      window.packageReservation = this
    },
  }
</script>
